import React from 'react'
import {style} from 'util/style'
import {useTranslation} from '../../util/i18n'
import {CardSwitchType} from './cards/CardSwitch'
import {Overview} from './Overview'

const styles = style('relatedprojects')

type RelatedProjectsType = {
	items: Array<CardSwitchType>
}

export const RelatedProjects: React.FC<RelatedProjectsType> = ({items}) => {
	const t = useTranslation('impact').projects.related

	return (
		<div className={styles()}>
			<Overview title={t.title} items={items} carousel />
		</div>
	)
}
